import React from 'react';
import {useIntl} from 'react-intl';
import ErrorPage from '../../common/ErrorPage/ErrorPage';
import PageTitle from '../PageTitle';
import {ACCESS_DENIED_TITLE_KEY} from './constants';
import {useIsDashboardLinkVisible} from './hooks/useIsDashboardLinkVisible';

export function AccessDenied() {
    const intl = useIntl();
    const isDashboardLinkVisible = useIsDashboardLinkVisible();

    const titleKey = ACCESS_DENIED_TITLE_KEY;
    const messageKey = ACCESS_DENIED_TITLE_KEY;

    const customTitleMessage = intl.formatMessage({id: titleKey, defaultMessage: 'Access Denied'});
    const customErrorMessage = intl.formatMessage({id: messageKey, defaultMessage: 'Access Denied'});

    return (
        <>
            <PageTitle pageTitle={customTitleMessage} />
            <ErrorPage
                isDashboardLinkVisible={isDashboardLinkVisible}
                customTitleMessage={customTitleMessage}
                customErrorMessage={customErrorMessage}
            />
        </>
    );
}
